<template>
  <Poptip @on-popper-show="onShow" trigger="click" content="content" placement="bottom" padding="0" v-if="!isEmpty(notifyOpts.channels)">
    <Badge :count='totalSum'>
      <i class="fa fa-bell fa-2x"></i>
    </Badge>
    <div v-if="remindConfig.routername" slot="content"></div>
    <component v-else-if="remindConfig.component" :is="remindConfig.component" slot="content"></component>
    <div v-else slot="content" style="display:flex;flex-direction: column;" class="remindlist">
      <div class="nomsg" v-if="!isRemindConfig&&IsGridInitOk&&gridOpts.dataSoucre.length==0" style="text-align:center;padding:4px">没有新的消息</div>

      <RecycleScroller style="max-height:400px;width: 250px;" :items="gridOpts.dataSoucre" :item-size="50" key-field="MsgID" v-slot="{ item }">
        <div style="display: flex;height: 100%;padding:2px 4px;width: 100%;" @click.stop="msgClick(item)" class="fx__item">
          <div style="display: flex;justify-content: center;align-items: center;" class="fx__opera">
            <span class="fx__item_ico" style="cursor: pointer;font-size: 18px;" @click.stop="deleteMsg(item)" title="已读"><i class="fa fa-trash-o"></i></span>
          </div>
          <div style="display: flex;flex:1;flex-direction:column;padding: 4px;min-width: 0px">
            <!-- min-width: 0px 这个很关键 -->
            <div style="width: 100%;flex:1;display: flex;align-items: center;justify-content: space-between;overflow: hidden;">
              <p style="flex:1;font-weight: bolder;;font-size: 14px;padding-right: 20px;" class="ellipsis" :title="item.MsgTitle">
                {{item.MsgTitle}}
              </p>
              <div>{{ formatTime(item.MsgTime)}}</div>
            </div>
            <div style="width: 100%;flex:1;display: flex;;align-items: center;justify-content: space-between;">
              <p style="flex:1;padding-right: 20px;" class="ellipsis" :title="item.MsgBody"> {{item.MsgBody}}</p>
              <div>
                <Badge :count="item.UnRead">
                </Badge>
              </div>
            </div>
          </div>
        </div>
      </RecycleScroller>

      <!-- <div style="text-align: center;margin-top: 5px" v-if="gridOpts.dataSoucre.length!=0">全部</div> -->
      <!-- <fx-grid :Opts="gridOpts" ref="grid1" class="gridlayout">
        <template v-slot:groups="{groups}">
          <div class="card fx__border" v-for="(group,index) in groups" :key="index" @click="group.isfold=!group.isfold">
            <div style="line-height: 25px;margin-left:5px" class="fx-flex fx-justify-between card-top">
              <div class="fx__simpleline ">{{group.groupText}}<span>&nbsp;&nbsp;●&nbsp;&nbsp;{{getTimeDiff(group.children[0].RowData.MsgTime)}}</span></div>
              <div><span class="msg_num fx__bgcolor-red">{{group.children.length}}</span><span style="position: relative;top: 2px" :ref="'arrows'+index">
                  <Icon color="gray" :class="{icon_rotate:group.isfold}" type="ios-arrow-up" size="20" />
                </span></div>
            </div>
            <div v-show="group.isfold" class="card_content">
              <div v-for="(item,index2) in group.children.slice(0,2)" :key="index2" class="fx-flex fx-justify-between">
                <div class="fx__simpleline "><span class="msg_title">{{item.RowData.MsgTitle}}</span>&nbsp;&nbsp;&nbsp;<span>{{getSummary(item.RowData)}}</span></div>
              </div>
            </div>
            <div v-show="!group.isfold">
              <div v-for="(item,index2) in group.children" :key="index2" @click.stop="msgClick(item)" style="padding:5px 7px" :class="[{'bottom_line': index2!=group.children.length-1}]" class="fx__item fx__border">
                <div style="height: 28px">{{getTimeDiff(item.RowData.MsgTime)}}</div>
                <div class="fx-flex fx-justify-between">
                  <div style="font-size: 10px" class="msg_title fx__simpleline">{{item.RowData.MsgTitle}}</div>
                  <div style="cursor: pointer;">
                    <Icon @click.stop="deleteMsg(item)" type="ios-trash-outline" size="18" class="delete" />
                  </div>
                </div>
                <div class="fx__simpleline">{{getSummary(item.RowData)}}</div>
              </div>
            </div>
          </div>
        </template>
      </fx-grid> -->
      <fx-notifyevent :Opts="notifyOpts" v-if="IsEventStart&&!isEmpty(notifyOpts.channels)" @msgs-change="msgchange"></fx-notifyevent>

      <div class="lookmsglist" v-if="isRemindConfig" style="text-align:center;padding:4px;cursor: pointer;" @click.stop="lookhistory">查看历史消息</div>
      <!--           <div style="text-align: center;margin-top: 5px" v-if="gridOpts.dataSoucre.length!=0" @click="deleteAllMsg"> <Icon type="md-trash" size="28"/></div>-->
    </div>
  </Poptip>
</template>

<script>
export default {
  data() {
    let channels = this.$app.Cfg.notify.moduleChannelDict["app-remind"]

    let isEmpty = lodash.isEmpty

    return {
      IsEventStart: false,
      IsGridInitOk: false,
      serverDate: new Date(),
      nowTime: new Date().getTime(),
      gridOpts: {
        groupRule: {}, //默认分组规则,必写
        keyword: "", //默认关键字,带监听连动
        dataSoucre: [], //数据源,带监听连动
        orderRule: {}, //默认排序规则
        filterRuleFnArr: [], //过滤规则函数数组,这里面是一个一个函数
        filterFnEx: {
          f1: null,
        }, //行过滤扩展函数用法是传入一个带参数函数,参数将被传入行数据Object
      },
      notifyOpts: {
        channels,
      },
      isEmpty,
      remindConfig: {},
    }
  },
  created() {},
  watch: {
    gridOpts: {
      deep: true,
      handler: function () {
        let serverTimestamp = new Date().getTime() + window.core_bstimediff
        this.serverDate = new Date(serverTimestamp)
      },
    },
  },
  computed: {
    isRemindConfig() {
      if (this.$store.state.notify.moduleNoticeNum["core-groupmsglist"] != undefined) {
        return true
      } else return false
    },
    totalSum() {
      let total = this.$store.state.notify.moduleNoticeNum["app-remind"]
      return total
    },
  },
  methods: {
    initData() {
      // 频道接入
      // let _this = this
      // var { options } = this.remindConfig
      // if (!options) return
      // if (!options.groupRule)
      //   this.$Notice.warning({
      //     title: "未实现铃铛消息分组groupRule",
      //     duration: 5000,
      //   })
      // if (!options.groupRule.groupFn)
      //   this.$Notice.warning({
      //     title: "未实现铃铛消息分组groupFn",
      //     duration: 5000,
      //   })
      // if (!options.groupRule.compareFn) {
      //   options.groupRule.compareFn = function (group1, group2) {
      //     let time1 = moment(group1.children[group1.children.length - 1].RowData.MsgTime)
      //     let time2 = moment(group2.children[group2.children.length - 1].RowData.MsgTime)
      //     return time1.diff(time2) * -1
      //   }
      // }
      // if (options.orderRule && !options.orderRule.compareFn) {
      //   options.orderRule.compareFn = function (row1, row2, group) {
      //     let time1 = moment(row1.MsgTime)
      //     let time2 = moment(row2.MsgTime)
      //     return time1.diff(time2) * -1
      //   }
      // }
      // _this.gridOpts.groupRule = options.groupRule
    },
    lookhistory() {
      let _this = this

      _this.$router.push({
        name: "core-groupmsglist",
      })
    },
    msgClick(item) {
      let _this = this
      if (_this.remindConfig && _this.remindConfig.hook && _this.remindConfig.hook.msgClick == "function") _this.remindConfig.hook.msgClick.call(this, item)
      else if (item.Subject) {
        //
        _this.$curl
          .post("/api/notify/setReaded", {
            MsgID: item.MsgID,
            IsClearUnReadCount: true,
          })
          .then(() => {
            _this.$router.push({
              name: "core-groupmsglist",
              query: {
                msgtype: item.MsgType,
              },
            })
          })
      } else if (item.route) {
        _this.$router.push(item.route)
      } else if (item.url) {
        window.open(item.url)
      }
    },

    onShow() {
      if (!this.$app.Cfg.notify.moduleChannelDict["app-remind"]) return
      fxImport("./web/config/remindcfg/remind.config.js")
        .then((res) => {
          if (lodash.isEmpty(res)) this.remindConfig = {}
          else this.remindConfig = res
        })
        .finally(() => {
          // this.initData()
          dealer()
        })

      let dealer = () => {
        this.nowDt = new Date()
        if (this.remindConfig.routername) {
          this.$router.push({ name: this.remindConfig.routername })
          return
        }

        if (this.IsEventStart == false) {
          //
          this.IsEventStart = true
        }
        this.nowTime = new Date().getTime()
        this.$nextTick(() => {
          let grid1 = this.$refs.grid1
          if (grid1)
            grid1.groups.forEach((element) => {
              element.isfold = true
            })
        })
      }
    },

    getTimeDiff(MsgTime) {
      let msgTimestamp = new Date(MsgTime).getTime()
      let serverTimestamp = this.serverDate.getTime()
      // let msgMomentTime= moment(msgTimestamp);
      // let serverMomentTime= moment(serverTimestamp);
      let sendDate = moment(msgTimestamp).format("YYYY-MM-DD")
      let sendTime = moment(msgTimestamp).format("HH:mm:ss")

      let sendTimeArry = moment(msgTimestamp)
        .format("YYYY-MM-DD HH:mm:ss")
        .split(/\s+|-|:/)
      let currentTimeArry = moment(serverTimestamp)
        .format("YYYY-MM-DD HH:mm:ss")
        .split(/\s+|-|:/)

      if (sendTimeArry[0] != currentTimeArry[0] || sendTimeArry[1] != currentTimeArry[1]) return sendDate

      if (sendTimeArry[2] != currentTimeArry[2]) {
        let diffDay = currentTimeArry[2] - sendTimeArry[2]
        if (diffDay == 1) return `昨日${sendTime}`
        if (diffDay <= 3) return `${diffDay}天前`
        return sendDate
      }
      if (sendTimeArry[3] != currentTimeArry[3]) {
        let diffHour = currentTimeArry[3] - sendTimeArry[3]
        return diffHour <= 3 ? `${diffHour}小时前` : `今天${sendTime}`
      }
      if (sendTimeArry[4] != currentTimeArry[4]) {
        let diffMinute = currentTimeArry[4] - sendTimeArry[4]
        return `${diffMinute}分钟前`
      }
      if (sendTimeArry[5] != currentTimeArry[5]) {
        let diffSecond = currentTimeArry[5] - sendTimeArry[5]
        return `${diffSecond}秒前`
      }
      if (sendTimeArry[5] == currentTimeArry[5]) {
        return `1秒前`
      }
    },

    formatTime(time) {
      let destDt = moment(time)

      let zeroDay = moment(this.serverDate.getTime()).startOf("day")
      let zeroYear = moment(this.serverDate.getTime()).startOf("year")

      if (destDt.diff(zeroDay, "day") == 0) {
        //今天
        return destDt.format("HH:mm")
      } else if (destDt.diff(zeroDay, "day") == -1) {
        //昨天
        return "昨天 " + destDt.format("HH:mm")
      } else if (zeroYear.year() == destDt.year()) {
        //同一年
        return destDt.format("MM-DD")
      } else {
        //更早
        return destDt.format("YYYY-MM-DD")
      }
    },

    msgchange({ msgs }) {
      let _this = this
      _this.gridOpts.dataSoucre = msgs

      if (msgs.length > 0 && this.IsGridInitOk == false) {
        this.$nextTick(() => {
          _this.IsGridInitOk = true
          let grid1 = _this.$refs.grid1
          if (grid1)
            grid1.groups.forEach((element) => {
              element.isfold = true
            })
        })
      }
    },

    deleteMsg(item) {
      this.$curl.post("/api/notify/setReaded", {
        MsgID: item.MsgID,
        IsClearUnReadCount: true,
      })
    },

    deleteAllMsg() {
      let _this = this
      _this.$curl.post("/api/notify/setAllReaded")
    },

    isJson(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str)
          if (typeof obj == "object" && obj) {
            return true
          } else {
            return false
          }
        } catch (e) {
          return false
        }
      }
    },

    getSummary(RowData) {
      let { options, hook } = this.remindConfig
      let { MsgData, MsgBody } = RowData

      //有钩子优先钩子
      if (hook.onGetSummary) {
        return hook.onGetSummary(RowData) || MsgData
      }

      if (MsgBody) return MsgBody

      //不是json就直接返回
      if (!this.isJson(MsgData)) return MsgData

      //是json尝试读取summary属性
      let MsgDataObj = JSON.parse(MsgData)
      return MsgDataObj.summary || MsgData
    },
  },
}
</script>

<style lang="scss">
.remindlist {
  .ellipsis {
    /* min-width: 0; */
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>


<style lang="scss" scoped>
.bottom_line {
  border-bottom: 1px solid;
}
.card {
  width: 320px;
  margin-top: 5px;
  padding-bottom: 5px;
  border-bottom: 1px solid;
  &:last-child {
    border-bottom: 0;
  }
  .card-top {
    font-size: 13px;
  }
}
.msg_num {
  display: inline-block;
  width: 28px;
  height: 18px;
  text-align: center;
  border-radius: 10px;
  line-height: 18px;
}
.card_content {
  padding: 0 7px;
}
.msg_title {
  font-weight: bold;
}

.icon_rotate {
  transform-origin: 50% 50%;
  transform: rotate(180deg);
}
</style>